import { z } from "zod"
import {
	SalesAddressLine2Schema,
	SalesAddressLineSchema,
	SalesFirstNameSchema,
	SalesLastNameSchema,
	SalesPhoneNumberSchema,
	SalesPostalCodeSchema,
} from "./SalesCommons"

export const SalesAddressModelSchema = z.object({
	first_name: SalesFirstNameSchema.nullable(),
	last_name: SalesLastNameSchema.nullable(),
	address1: SalesAddressLineSchema.nullable(),
	address2: SalesAddressLine2Schema.nullable(),
	province: z.string().min(1).nullable(),
	city: z.string().min(1).nullable(),
	postal_code: SalesPostalCodeSchema.nullable(),
	suburb: z.string().min(1).nullable(),
	phone: SalesPhoneNumberSchema.nullable(),
})
export type SalesAddressModel = z.infer<typeof SalesAddressModelSchema>

export const emptySalesAddress: SalesAddressModel = {
	first_name: null,
	last_name: null,
	address1: null,
	address2: null,
	province: null,
	city: null,
	postal_code: null,
	suburb: null,
	phone: null,
}

export const SalesInvoiceAddressModelSchema = SalesAddressModelSchema.extend({
	company_name: z.string().min(1).nullable(),
	vat_number: z.string().min(1).nullable(),
})
export type SalesInvoiceAddressModel = z.infer<typeof SalesInvoiceAddressModelSchema>

export const emptySalesInvoiceAddress: SalesInvoiceAddressModel = {
	...emptySalesAddress,
	company_name: null,
	vat_number: null,
}
